import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=015fe92a&scoped=true&"
import script from "./TaskComments.vue?vue&type=script&lang=js&"
export * from "./TaskComments.vue?vue&type=script&lang=js&"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=015fe92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fe92a",
  null
  
)

export default component.exports